import GameCard from 'components/game/GameCard';
import React, {useEffect, memo, useMemo, Fragment} from 'react';
import SvgText from 'components/SvgText';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {FormattedMessage, useIntl} from 'react-intl';
import {CARD_NAME} from '../GameRule';
import './CardContent.scss';

const CardDisplaySetting = {
  [CARD_NAME.DIG]: {
    emoji: '⛏️',
  },
  [CARD_NAME.TRANNING]: {
    emoji: '🙄',
  },
  [CARD_NAME.REST]: {
    emoji: '🧘',
  },
  [CARD_NAME.LONG_THINKING]: {
    emoji: '😪',
  },
  [CARD_NAME.ATK_BACK]: {
    emoji: '✊',
  },
  [CARD_NAME.LONG_TRANNING]: {
    emoji: '💪',
  },
};


export const getCardDescription = (cardName, setting, intl) => {
  const { type } = setting || {};
  const NONE_TRANSLATE = 'NONE_TRANSLATE';
  let cardDescription = '', typeDescription = '';
  if (setting?.type) {
    const typeName = intl.formatMessage({ id: `game.GamePage.card.type.name.${type}`, defaultMessage: NONE_TRANSLATE });
    if (typeName !== NONE_TRANSLATE) {
      // typeDescription = `${typeName}: ${intl.formatMessage({ id: `game.GamePage.card.type.description.${type}` })}`;
      typeDescription =
        <Fragment>
          <b>{typeName}</b>:
          {intl.formatMessage({ id: `game.GamePage.card.type.description.${type}` })}
        </Fragment>;
    }
  }

  if (cardName) {
    const cardNameStr = intl.formatMessage({
      id: `game.GamePage.card.name.${cardName}`,
      defaultMessage: NONE_TRANSLATE
    });
    const cardDescriptionStr = intl.formatMessage({
      id: `game.GamePage.card.description.${cardName}`,
      defaultMessage: NONE_TRANSLATE
    });
    if (cardDescriptionStr !== NONE_TRANSLATE) {
      cardDescription = <Fragment><b>{cardNameStr}</b>: {cardDescriptionStr}</Fragment>;
    }
  }
  // const result = [cardDescription, typeDescription].filter(item => !!item).join('\n');
  const result = <Fragment>
    <p>{cardDescription}</p>
    <p>{typeDescription}</p>
  </Fragment>
  return result;
}

const CardContent = (props) => {
  const { data = {}, className = '' } = props;
  const { name: cardName, species, status, setting = {} } = data;
  const { type } = setting;
  let gameCardClassName = `${className} game-card card-setting-type-${type}`;
  const intl = useIntl();
  let title = getCardDescription(cardName, setting, intl);
  const content = JSON.stringify(data);
  let label = 'One Card';
  let emoji = '🙃';
  if (cardName === CARD_NAME.MEMBER) {
    const { id, emoji: speciesEmoji } = species;
    const { hp, atk, def } = status;
    label = (
      <FormattedMessage
        id={`game.GamePage.member.${id}`}
        defaultMessage={id}
      />
    );
    emoji = speciesEmoji;
  } else if (cardName === CARD_NAME.THINKING) {
    emoji = '🤔';
    label = (<FormattedMessage id="game.GamePage.card.name.THINKING" defaultMessage="THINKING"/>);
  } else if (cardName === CARD_NAME.ATK) {
    emoji = '👊';
    label = (<FormattedMessage id="game.GamePage.card.name.ATK" defaultMessage="ATK"/>);
  } else {
    label = (<FormattedMessage id={`game.GamePage.card.name.${cardName}`} defaultMessage={cardName}/>);
    if (CardDisplaySetting[cardName]) {
      const setting = CardDisplaySetting[cardName];
      emoji = setting.emoji;
    }
  }
  return (
    <GameCard {...props} label={label} emoji={emoji} className={gameCardClassName} title={title}/>
  );
};

export default CardContent;
